<div class="pagination-container">
	<div class="pagination">
		<md-drop-down
			class="dropdown"
			[options]="itemsPerPageSelections()"
			[value]="itemsPerPage()"
			(change)="onPageLengthChange($event)"
			md-form-input
			md-select-input
		>
		</md-drop-down>

		<md-button-group [value]="displayPage()">
			<md-button-toggle
				[value]="displayPage() - 1"
				[disableDeselect]="true"
				[disableSelect]="true"
				(click)="onPageChange(displayPage() - 1)"
				[disabled]="displayPage() === 1"
				class="first-btn"
			>
				<md-icon>keyboard_arrow_left</md-icon>
				Previous
			</md-button-toggle>

			@for (pageItem of pages(); track $index) {
				<md-button-toggle [value]="pageItem.value" [disableDeselect]="true" (click)="onPageChange(pageItem.value)" class="toggles">
					{{ pageItem.type === 'ellipsis' ? '...' : pageItem.value }}
				</md-button-toggle>
			}

			<md-button-toggle
				md-button
				[disableDeselect]="true"
				[disableSelect]="true"
				[value]="displayPage() + 1"
				(click)="onPageChange(displayPage() + 1)"
				[disabled]="displayPage() === totalPages()"
				class="last-btn"
			>
				Next<md-icon>keyboard_arrow_right</md-icon>
			</md-button-toggle>
		</md-button-group>
	</div>
</div>
